export const GET_CONTAINERS_LIST_IN_PROGRESS =
  "GET_CONTAINERS_LIST_IN_PROGRESS";
export const GET_CONTAINERS_LIST_SUCCESS = "GET_CONTAINERS_LIST_SUCCESS";
export const GET_CONTAINERS_LIST_FAIL = "GET_CONTAINERS_LIST_FAIL";

export const GET_CONTAINERS_LIST_FILTERS_IN_PROGRESS =
  "GET_CONTAINERS_LIST_FILTERS_IN_PROGRESS";
export const GET_CONTAINERS_LIST_FILTERS_SUCCESS =
  "GET_CONTAINERS_LIST_FILTERS_SUCCESS";
export const GET_CONTAINERS_LIST_FILTERS_FAIL =
  "GET_CONTAINERS_LIST_FILTERS_FAIL";

export const GET_CONTAINERS_LIST_COUNT_IN_PROGRESS =
  "GET_CONTAINERS_LIST_COUNT_IN_PROGRESS";
export const GET_CONTAINERS_LIST_COUNT_SUCCESS =
  "GET_CONTAINERS_LIST_COUNT_SUCCESS";
export const GET_CONTAINERS_LIST_COUNT_FAIL = "GET_CONTAINERS_LIST_COUNT_FAIL";

export const GET_CONTAINERS_LIST_TOTAL_LOAD_IN_PROGRESS =
  "GET_CONTAINERS_LIST_TOTAL_LOAD_IN_PROGRESS";
export const GET_CONTAINERS_LIST_TOTAL_LOAD_SUCCESS =
  "GET_CONTAINERS_LIST_TOTAL_LOAD_SUCCESS";
export const GET_CONTAINERS_LIST_TOTAL_LOAD_FAIL =
  "GET_CONTAINERS_LIST_TOTAL_LOAD_FAIL";
